import * as React from "react";
import { Spinner } from "@fluentui/react-components";
import { Container } from "./Container";

export interface ProgressProps {
  message: string;
}

export default class Progress extends React.Component<ProgressProps> {
  render() {
    const { message } = this.props;

    return (
      <Container>
        <Spinner size="large" label={message} />
      </Container>
    );
  }
}
